import React, { useState } from 'react'
import { Chart } from "react-google-charts";


// graph for Notice view
const NoticeViewGraph = ({ noticeViewGraphData }) => {
    let noticeViewGraphDataArray = [["x", "y"]];

    noticeViewGraphData && Object.keys(noticeViewGraphData).map(key => {
        noticeViewGraphDataArray.push([key, noticeViewGraphData[key]])
    });

    const options = {
        titleTextStyle: {
            color: 'blue',
        },
        curveType: "function",
        legend: { position: "none" },
    };

    return (
        <section className='h-100'>
            { 
                noticeViewGraphDataArray.length > 1 ?
                    <Chart
                        height="100%"
                        chartType="LineChart"
                        width="100%"
                        data={ noticeViewGraphDataArray }
                        options={ options }
                    />
                :
                    <p style={{ margin: 20, color: '#818181', fontSize: 14 }}>No details found for notice views.</p>
            }
        </section>
    )
}

export default NoticeViewGraph
